/* eslint-disable */
;(function () {
    window.addEventListener('DOMContentLoaded', function (e) {
        var contentArray = [
        //     {
        //         // 离线宝1
        //         type: 'text/javascript',
        //         useSafeDOM: false,
        //         innerHTML: `var _hmt = _hmt || [];
        //   (function() { var hm = document.createElement("script");
        //   hm.src = "https://hm.baidu.com/hm.js?09b47920339ef92ef378b02fe5ec7488";
        //   var s = document.getElementsByTagName("script")[0];
        //   s.parentNode.insertBefore(hm, s); })();`,
        //         attr: {
        //             id: 'lixianbao1'
        //         }
        //     },
        //     {
        //         // 离线宝2
        //         type: 'text/javascript',
        //         src: 'https://lxbjs.baidu.com/lxb.js?sid=11768749',
        //         attrs: {
        //             async: '',
        //             id: 'lixianbao2',
        //             charset: 'utf-8'
        //         }
        //     },
        //     {
        //         // 百度统计pc
        //         type: 'text/javascript',
        //         useSafeDOM: false,
        //         innerHTML: `var _hmt = _hmt || [];
        //   (function() {
        //     var hm = document.createElement("script");
        //     hm.src = "https://hm.baidu.com/hm.js?09b47920339ef92ef378b02fe5ec7488";
        //     var s = document.getElementsByTagName("script")[0];
        //     s.parentNode.insertBefore(hm, s);
        //   })();`
        //     },
        //     {
        //         // cnzz
        //         type: 'text/javascript',
        //         src: 'https://s22.cnzz.com/z_stat.php?id=1265798262',
        //         attrs: {
        //             class: 'cnzz',
        //             id: 'cnzz_script'
        //         }
        //     },
            {
                // 美洽
                type: 'text/javascript',
                useSafeDOM: false,
                innerHTML: ` (function(m,  ei,  q,  i,  a,  j,  s)  {
                m[i]  =  m[i]  ||  function()  {
                        (m[i].a  =  m[i].a  ||  []).push(arguments)
                };
                j  =  ei.createElement(q),
                        s  =  ei.getElementsByTagName(q)[0];
                j.async  =  true;
                j.charset  =  'UTF-8';
                j.src  =  'https://static.meiqia.com/dist/meiqia.js?_=t';
                s.parentNode.insertBefore(j,  s);
        })(window,  document,  'script',  '_MEIQIA');
        _MEIQIA('entId',  105911);`,
                attr: {
                    class: 'zhiCustomBtn',
                    id: 'zhichiScript'
                }
            }
        ];
        var camelConverse = function (src) {
            var reg = /([A-Z])/g;
            return src.replace(reg, '-$1').toLocaleLowerCase()
        };
        var esStringConcat = function (src) {
            return `window.addEventListener('DOMContentLoaded', function (e) {` + src + `})`
        };
        var scriptGenerator = function (data) {
            var frg = document.createDocumentFragment();
            data.forEach(function (item, index) {
                var script = document.createElement('script');
                if (item.src) {
                    script.src = item.src
                }
                if (item.attrs) {
                    for (var k in item.attrs) {
                        script.setAttribute(camelConverse(k), item.attrs[k])
                    }
                }
                if (item.innerHTML) {
                    script.innerHTML = item.useSafeDOM
                        ? esStringConcat(item.innerHTML).replace('`', '')
                        : item.innerHTML.replace('`', '')
                }
                frg.appendChild(script)
            });
            return frg
        };
        document.getElementsByTagName('body')[0].appendChild(scriptGenerator(contentArray));
    })
})();
